import * as Yup from 'yup';

export const MedicalConditionsValidSchema = Yup.object().shape({
    // authorized: Yup.boolean(),
    // documentAuthorized: Yup.mixed().when('authorized', {
    //     is: false,
    //     then: (schema) => schema.optional(),
    //     otherwise: (schema) => schema.required("Informe o arquivo"),
    // }),
});